var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrcodeIcon = function SvgQrcodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18h-2v-2h2v2Zm-2-7H8v5h2v-5Zm8-2h-2v4h2V9Zm-2-2h-2v2h2V7ZM4 9H2v2h2V9ZM2 7H0v2h2V7Zm7-5h2V0H9v2Zm-7.5-.5v3h3v-3h-3ZM5 6H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-3.5 7.5v3h3v-3h-3ZM5 18H1c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm8.5-16.5v3h3v-3h-3ZM17 6h-4c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-1 10v-3h-4v2h2v3h4v-2h-2Zm-2-7h-4v2h4V9Zm-4-2H4v2h2v2h2V9h2V7Zm1-1V4H9V2H7v4h4ZM3.75 2.25h-1.5v1.5h1.5v-1.5Zm0 12h-1.5v1.5h1.5v-1.5Zm12-12h-1.5v1.5h1.5v-1.5Z"
  })));
};
export default SvgQrcodeIcon;